import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import { mergeMuiSx } from '../lib/muiSxArray'
import illustration011 from '@/features/auth/assets/login/illustration-011.svg'
import illustration022 from '@/features/auth/assets/login/illustration-022.svg'
import illustration033 from '@/features/auth/assets/login/illustration-033.svg'
import illustration044 from '@/features/auth/assets/login/illustration-044.svg'
import illustration055 from '@/features/auth/assets/login/illustration-055.svg'
type LayerInset = {
  readonly src: string
  readonly top: string
  readonly right: string
  readonly bottom: string
  readonly left: string
}

/** Figma 5074:11770 — layered illustration "4" */
const LAYERS: LayerInset[] = [
  {
    src: illustration055,
    top: '18.44%',
    right: '18%',
    bottom: '48.74%',
    left: '13.74%',
  },
  {
    src: illustration044,
    top: '10.86%',
    right: '27.17%',
    bottom: '10.83%',
    left: '34.4%',
  },
  {
    src: illustration033,
    top: '89.06%',
    right: '2.96%',
    bottom: '10.83%',
    left: '2.96%',
  },
  {
    src: illustration022,
    top: '50.5%',
    right: '53.31%',
    bottom: '9.83%',
    left: '4.52%',
  },
  {
    src: illustration011,
    top: '51.37%',
    right: '3.41%',
    bottom: '10.8%',
    left: '69.87%',
  },
]

function IllustrationLayer({ src, top, right, bottom, left }: LayerInset) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top,
        right,
        bottom,
        left,
        overflow: 'visible',
      }}
    >
      <Box
        component="img"
        src={src}
        alt=""
        draggable={false}
        sx={{
          display: 'block',
          width: '100%',
          height: '100%',
          maxWidth: 'none',
        }}
      />
    </Box>
  )
}

type LoginIllustrationProps = {
  readonly sx?: SxProps<Theme>
}

export function LoginIllustration({ sx }: LoginIllustrationProps) {
  return (
    <Box
      data-testid="login-illustration"
      sx={mergeMuiSx(
        {
          position: 'relative',
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          flexShrink: 0,
          overflow: 'visible',
        },
        sx
      )}
      aria-hidden
    >
      {LAYERS.map((layer) => (
        <IllustrationLayer key={layer.src} {...layer} />
      ))}
    </Box>
  )
}
